module.exports = __webpack_public_path__ + "img/Footer_6262.001c980c.jpg";